import { AsyncPipe } from '@angular/common';
import { AfterContentInit, Component, ElementRef, HostBinding, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';
import { Member } from 'src/app/models';
import { AuthService } from 'src/app/services/auth';
import { ContentService, sections } from 'src/app/services/content/content.service';
import { DialogService } from 'src/app/services/dialog/dialog.service';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { ContentSection } from 'src/app/shared/layout/content-section';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-member-bar',
  templateUrl: './member-bar.component.html',
  styleUrls: ['./member-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, MatIconModule],
})
export class MemberBarComponent extends ContentSection implements OnInit, AfterContentInit {
  private authService = inject(AuthService);
  private dialogService = inject(DialogService);
  private themeService = inject(ThemeService);
  private elRef = inject(ElementRef);

  ordersUrl = `/${environment.urls.orders}`;
  @HostBinding('class.alternative-background') get alternativeBackground() {
    return this.altBackground;
  }

  member$: Observable<Member>;

  loginButton: string;
  logoutButton: string;

  altBackground: boolean;

  constructor() {
    const contentService = inject(ContentService);
    super(contentService, 'account');

    this.loginButton = this.content.get('menuLoginButtonText') || 'Kontokunde - log ind';
    this.logoutButton = this.content.get('menuLogoutButtonText') || 'Log ud';

    this.altBackground = this.contentService.get(sections.header).get('backgroundColor') === true.toString();
  }

  ngOnInit() {
    this.member$ = this.authService.member;
  }

  ngAfterContentInit() {
    this.themeService.subscribeComponent(this.elRef);
  }

  openLoginDialog() {
    this.dialogService.openLoginDialog();
  }

  logout() {
    this.authService.logout();
  }
}
